import packageJson from '../../package.json'

export default class Environment {
    environments = {
        production: {
            apiServer: {
                host: "https://api.ampulacorp.com"
            }
        },
        staging: {
            apiServer: {
                host: "https://api-staging.ampulacorp.com"
            }
        },
        development: {
            apiServer: {
                host: "https://api-dev.ampulacorp.com"
            }
        },
        local: {
            apiServer: {
                host: "http://localhost:9090"
            }
        }
    }

    getEnvironment() {
        let host = window.location.href;

        if (host.indexOf('u.ampoza.com') !== -1) {
            return this.environments.production
        } else if (host.indexOf('u-staging.ampoza.com') !== -1) {
            return this.environments.staging
        } else if (host.indexOf('u-dev.ampoza.com') !== -1) {
            return this.environments.development
        }

        return this.environments.local
    }

    getApiServer() {
        return this.getEnvironment().apiServer;
    }

    getHost () {
        return this.getApiServer().host;
    }

    getVersion () {
        return packageJson.version
    }
}
